import React from 'react';
import IconSVG from "svg-inline-react";

import './InstantBookingHeader.scss';

export default ({ title, subtitle }) => {
    return (
        <div className="InstantBookingHeader">
            <div>
            {
                title &&
                    <h1>
                        {title}
                    </h1>
            }
            {
                subtitle &&
                <h2>
                    {subtitle}
                </h2>
            }
            </div>

            <div className="infoBlockConsultation">
                <div>
                    <p>Помощь в размещении заявки на перевозку <a href="tel:+79188900295">+7 (918) 890-02-95</a></p>
                    <span>Бесплатная консультация</span>
                </div>

                <IconSVG
                    className="infoBlockConsultation-consultationIcon"
                    src={require('!svg-inline!./consultant.svg')}/>
            </div>
        </div>
    );
}



// WEBPACK FOOTER //
// ./client/components/InstantBookingHeader/InstantBookingHeader.js